<div class="modal-header">
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="closeModal()"
  >
    <span class="icon__close" aria-hidden="true">&times;</span>
    <i class="icon__close-mobile bi bi-arrow-left-short"></i>
  </button>
</div>
<div class="modal-body">
  <img [src]="productImage" alt="Alimento Seco" class="img-fluid" />
</div>
